module.exports = __webpack_public_path__ + "img/sleepwalkinglogo.9a85d7d3.png";